'use strict';

/* globals define, window, $, config, ajaxify, utils */

define('conference', [
	'//8x8.vc/external_api.js',
], function (JitsiMeetExternalAPI) {
	var	Conference = {};

	Conference.init = function (roomName, jitsiServer, username, jwt) {
		showMessageIfNotChromium();
		initJitsiRoom(roomName, jitsiServer, username, jwt);
		checkVideoPrivileges();
		checkAudioPrivileges();
	};

	function initJitsiRoom(roomName, jitsiServer, username, jwt) {
		var options = {
			roomName: roomName,
			jwt: jwt,
			height: 600,
			parentNode: document.querySelector('#jitsi-conference'),
			configOverwrite: { disableDeepLinking: true }
		}
		
		Conference.Jitsi = new JitsiMeetExternalAPI(jitsiServer, options);

		Conference.Jitsi.addListener('videoConferenceLeft', function () {
			$(window).trigger('jitsi:call:ended');
		});
	}

	function showMessageIfNotChromium() {
		if(!window.chrome) {
			$('#not-chromium').show();
		}
	}

	function checkVideoPrivileges() {
		checkPrivileges({ video: true }, function () {
			$('#video-permission-needed').show();
		});
	}

	function checkAudioPrivileges() {
		checkPrivileges({ audio: true }, function () {
			$('#audio-permission-needed').show();
		});
	}

	function checkPrivileges(permission, notAvailableCallback) {
		navigator.getMedia = (navigator.getUserMedia || // use the proper vendor prefix
			navigator.webkitGetUserMedia ||
			navigator.mozGetUserMedia ||
			navigator.msGetUserMedia);

		if (!navigator.getMedia) {
			return;
		}

		navigator.getMedia(permission, function() {
			// available
		}, notAvailableCallback);
	}

	return Conference;
});
